import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './Tooltip.module.css';

import { clsxm } from '@/shared/lib';

import { ITooltipProps } from './ITooltip';

// placement - hasArrow - arrowPlacement - py - px - children - trigger

const TooltipTemp: FC<ITooltipProps> = ({
  arrow = false,
  children,
  content = '',
  placement = 'left',
  wrapperClassName = '',
  className = '',
  trigger = true,
  center,
  bg = 'bg-white',
  onHover = true,
  ...props
}) => {
  const placementStyle = clsx(
    placement === 'left'
      ? 'right-full top-0 '
      : placement === 'right'
      ? 'left-full top-0 '
      : placement === 'bottom'
      ? 'bottom-full bottom-0'
      : placement === 'top'
      ? 'top-full top-[100%]'
      : ''
  );
  const arrowColors = {
    'bg-background-200': 'after:border-b-background-200',
    'bg-white': 'after:border-b-white',
  };

  const tooltipStyle = clsxm(
    styles['tooltip'],
    onHover ? 'hidden group-hover:flex' : 'flex',
    placementStyle,
    arrow ? styles[`arrow-${placement}`] : '',
    `after:border-t-background-transparent after:border-r-background-transparent after:border-l-background-transparent`,
    arrowColors[bg],
    center && placement === 'top' && 'right-1/2 translate-x-1/2',
    wrapperClassName
  );

  const tooltipContentStyle = clsxm(styles['content'], className, bg);

  return (
    <span className='group relative'>
      {children}
      {trigger && (
        <div role='tooltip' className={tooltipStyle} {...props}>
          <div className={tooltipContentStyle}>{content}</div>
        </div>
      )}
    </span>
  );
};

export default TooltipTemp;
